import React from 'react';

const PreloaderComponent = () => {
  return <div>PreloaderComponent</div>;
};

export default PreloaderComponent;
